import { css } from "@emotion/react"

export const productListItemStyle = css`
	display: grid;
	grid-template-columns: 24px 54px 1fr auto;
	gap: 12px;
	padding-bottom: 10px;
	border-bottom: 1px solid #d1d5db;

	:last-child {
		border-bottom: 1px solid transparent;
	}

	.chip {
		font-size: 14px;
		line-height: 13px;
		width: 24px;
		height: 24px;
		display: flex;
		border-radius: 50%;
		background-color: #e5e7eb;
		justify-content: center;
		align-items: center;
		padding: 3px;
		box-sizing: border-box;
	}

	.chip-active {
		background: #0682ff;
		font-weight: 700;
		color: white;
	}
`

export const partImageStyle = css`
	width: 54px;
	height: 54px;
	padding: 4px;
	border-radius: 2.702px;
	border: 0.675px solid #e5e6e6;
	display: flex;
	align-items: center;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		aspect-ratio: 1 / 1;
	}
`

export const inStockStyle = css`
	color: #10a85f;
	font-size: 14px;
	font-weight: 700;
`

export const priceStyle = css`
	color: #111827;
	font-size: 20px;
	font-weight: 700;
`

export const noteStyle = css`
	color: #374151;
	font-size: 14px;
`

export const productListItemDetailStyle = css`
	display: flex;
	flex-direction: column;
	gap: 5px;
`

export const explodedViewProductListStyle = css`
	max-height: 676px;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: 10px;
`

export const suggestedStyle = css`
	margin-top: 0.5rem;
	h5 {
		margin-bottom: 12px;
		font-size: 14px;
	}
	span {
		font-size: 1rem;
		font-weight: 700;
		margin-right: 0.5rem;
	}
`

export const cartContainer = css`
	h5 {
		font-size: 14px;
	}
`

export const cartActionsStyle = css`
	display: flex;
	flex-direction: row;
	gap: 12px;
	padding-top: 12px;
`

export const cartQtySelectStyle = css`
	select {
		height: 50px;
		width: 88px;
	}
`
